import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface HaggleMonthPickerComponentProps {
	selectedDate: Date | null;
	onChange: (date: Date | null) => void;
	dateFormat?: string;
	showMonthYearPicker?: boolean;
	className?: string;
	ariaLabel?: string;
}

const HaggleMonthPickerComponent: React.FC<HaggleMonthPickerComponentProps> = ({
	selectedDate,
	onChange,
	dateFormat = 'MMMM yyyy', // Default format
	showMonthYearPicker = false, // Default value
	className = 'p-2 border border-gray-300 rounded-md cursor-pointer', // Default style
	ariaLabel = 'Select date', // Default aria-label
}) => {
	// Default renderMonthContent logic specifically for month/year picker
	const renderMonthContentDefault = (
		month: number,
		shortMonth: string,
		longMonth: string,
		day: Date,
	) => {
		const year = day.getFullYear();
		const currentDate = new Date();
		const isCurrentMonth =
			month === currentDate.getMonth() && year === currentDate.getFullYear();
		const tooltipText = `${longMonth} ${year}`;

		return (
			<div
				className="flex flex-col items-center justify-center py-1"
				title={tooltipText}
			>
				<span
					className={`w-full h-full rounded-full px-4 py-2 text-center font-medium ${
						isCurrentMonth ? 'font-bold' : ''
					}`}
				>
					{shortMonth}
				</span>
			</div>
		);
	};

	return (
		<DatePicker
			selected={selectedDate}
			onChange={onChange}
			dateFormat={dateFormat}
			showMonthYearPicker={showMonthYearPicker}
			className={className}
			aria-label={ariaLabel}
			// Only apply the custom renderMonthContent if showMonthYearPicker is true
			renderMonthContent={
				showMonthYearPicker ? renderMonthContentDefault : undefined
			}
		/>
	);
};

export default HaggleMonthPickerComponent;
